var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTableV2',{attrs:{"parentID":this.parentID,"title":"Organisations","headers":[
      { text: 'ID', value: 'id' },
      { text: 'Organisation Name', value: 'companyname' },
      { text: 'Organisation Description', value: 'description', editable: true} ],"url":"/schemas/organisations","apiResponseField":"organisations","onClickRoute":"OrganisationSingle","onClickParams":_vm.getOnClickParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }